export default function LifestyleGallery() {
  const images = [
    {
      src: "https://public.readdy.ai/ai/img_res/d47cade7f9dc357fbb6ca258c3fd47f9.jpg",
      alt: "Beauty Supplement Routine",
      title: "Beauty Supplement Routine",
      link: "/beauty-supplement"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Handsome%20athletic%20man%20preparing%20protein%20shake%20in%20gym%20kitchen%2C%20holding%20supplement%20container%20and%20shaker%20bottle%2C%20post-workout%20nutrition%20routine%2C%20modern%20fitness%20lifestyle%20photography%20with%20natural%20lighting&width=600&height=800&seq=lifestyle014protein&orientation=portrait", 
      alt: "Post-Workout Nutrition",
      title: "Post-Workout Nutrition",
      link: "/post-workout"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Young%20woman%20organizing%20colorful%20supplement%20bottles%20in%20modern%20bathroom%20cabinet%2C%20weekly%20pill%20organizer%20on%20marble%20countertop%2C%20wellness%20planning%20and%20health%20routine%2C%20organized%20nutrition%20lifestyle%20photography&width=600&height=800&seq=lifestyle015organize&orientation=portrait",
      alt: "Wellness Planning",
      title: "Wellness Planning",
      link: "/vitamins"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Fit%20man%20drinking%20green%20superfood%20smoothie%20after%20morning%20workout%2C%20holding%20supplement%20powder%20container%2C%20gym%20background%20with%20weights%2C%20health%20and%20fitness%20nutrition%20lifestyle%20photography&width=600&height=800&seq=lifestyle016superfood&orientation=portrait",
      alt: "Superfood Nutrition",
      title: "Superfood Nutrition",
      link: "/sports-nutrition"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Pregnant%20woman%20taking%20prenatal%20vitamins%20at%20kitchen%20table%20with%20healthy%20meal%2C%20holding%20supplement%20bottle%20with%20gentle%20smile%2C%20nurturing%20maternal%20wellness%20routine%20with%20soft%20natural%20lighting%20and%20peaceful%20atmosphere%2C%20family%20health%20lifestyle%20photography&width=600&height=800&seq=lifestyle017prenatal&orientation=portrait",
      alt: "Prenatal Wellness",
      title: "Prenatal Wellness",
      link: "/vitamins"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Athletic%20man%20and%20woman%20sharing%20healthy%20smoothie%20with%20supplement%20powders%2C%20workout%20clothes%20in%20modern%20kitchen%2C%20couple%20wellness%20routine%20with%20protein%20shakers%2C%20active%20lifestyle%20nutrition%20photography&width=600&height=800&seq=lifestyle018couple&orientation=portrait",
      alt: "Couples Wellness",
      title: "Couples Wellness",
      link: "/health-wellness"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Professional%20woman%20taking%20stress%20relief%20supplements%20at%20office%20desk%20with%20healthy%20lunch%20and%20herbal%20tea%2C%20maintaining%20wellness%20routine%20during%20busy%20workday%20with%20calm%20focused%20expression%2C%20work-life%20balance%20lifestyle%20photography%20with%20natural%20office%20lighting&width=600&height=800&seq=lifestyle019stressrelief&orientation=portrait",
      alt: "Stress Management",
      title: "Stress Management",
      link: "/brain-support"
    },
    {
      src: "https://readdy.ai/api/search-image?query=Senior%20woman%20reading%20supplement%20labels%20in%20modern%20pharmacy%20or%20health%20store%2C%20comparing%20different%20vitamin%20bottles%20with%20reading%20glasses%2C%20informed%20health%20choices%20lifestyle%20photography%20with%20warm%20lighting&width=600&height=800&seq=lifestyle020senior&orientation=portrait",
      alt: "Informed Health Choices",
      title: "Informed Health Choices",
      link: "/immunity"
    }
  ];

  const handleClick = (link: string) => {
    window.REACT_APP_NAVIGATE(link);
  };

  return (
    <section className="py-16 bg-gradient-to-b from-emerald-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Your Supplement Journey
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From beauty supplements to performance nutrition, discover how wellness fits into every lifestyle
          </p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {images.map((image, index) => (
            <div 
              key={index}
              onClick={() => handleClick(image.link)}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-semibold text-sm">
                    {image.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
